import React from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import myLogo from '../../LOGO.png';


const VoiceLayout = () => {
  const location = useLocation(); // Get the current location
  const currentPath = location.pathname; // Get the current path

  const navigate = useNavigate();

  const handleGoToDashboard = () => {
    navigate('/dashboard');
  };

  const handleLogout = (e) => {
    e.preventDefault();
    // Create a hidden form to perform a POST logout
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = `${process.env.REACT_APP_NOTIFICATION_SERVICE_APIGW_ENDPOINT}/logout`;
    document.body.appendChild(form);
    form.submit();
  };

  return (
    <div className="layout">

      <div className="main-content">
        <nav className="side-pane">
          <ul>
            <li><Link to=""
              className={currentPath === '/voice' ? 'active' : ''}>Voice Notification Sent</Link></li>
            <li><Link to="voice-template"
              className={currentPath === '/voice/voice-template' ? 'active' : ''}>Voice Template Maintenance</Link></li>
            <li><Link to="voice-category"
              className={currentPath === '/voice/voice-category' ? 'active' : ''}>Voice Category</Link></li>
            <li><Link to="voice-template-variable"
              className={currentPath === '/voice/voice-template-variable' ? 'active' : ''}>Voice Template Variable</Link></li>
            <li><Link to="voice-system-variable"
              className={currentPath === '/voice/voice-system-variable' ? 'active' : ''}>Voice System Variable</Link></li>
            <li className="logout-item">
              <button
                type="button"
                onClick={handleLogout}
                className="logout-button"
                style={{ marginTop: '20px', cursor: 'pointer' }}
              >
                Logout
              </button>
            </li>
            <li className="back-to-dashboard-item">
              <button
                type="button"
                onClick={handleGoToDashboard}
                className="back-to-dashboard-button"
                style={{ marginTop: '20px', cursor: 'pointer' }}
              >
                Dashboard
              </button>
            </li>
          </ul>
        </nav>
        <div className="content-pane">
          <Outlet /> {/* This is crucial for rendering child route components */}
          <footer className="company-footer">
            <img src={myLogo} alt="Logo" className="footer-logo" />

            <div className="footer-info">
              <p className="copyright-text">
                &copy; {new Date().getFullYear()} PRIMEDHA Technologies Pvt Ltd. All rights reserved.
              </p>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default VoiceLayout;
